import i18n from '@/utils/i18n';
import store from '@/store'
import { getToken, setToken } from '@/utils/auth'
import { helpJsonParse } from '@/utils/index'
export default function initStorageListener() {
  const keyWords = `${getToken('key')}_isFirst`
  if (!getToken(keyWords)) {
    localStorage.removeItem('userShifts')
    setTimeout(() => {
      console.log(i18n.t("utilsSharestorage.putInTheInitialMarker"), keyWords)
      setToken(true, keyWords)
    }, 2000)
  }
  clearCookie()
  const dispatchEventEnum = {
    printSettings: 'SET_PRINT_SETTING',
    userShifts: 'SET_SHIFTS',
    nightAudit: 'SET_NIGHT_AUDIT_STATUS',
    showGlobalTip: 'SET_GLOBAL_TIP'
  }
  window.addEventListener('storage', e => {
    const { key, newValue = '', oldValue = '' } = e
    if (key && dispatchEventEnum[key]) { // 说明是修改了localStorage
      const vuexKey = dispatchEventEnum[key]
      const updateValue = newValue === 'null' ? null : newValue
      store.commit(`user/${vuexKey}`, {
        data: updateValue && updateValue.includes('{') ? helpJsonParse(updateValue) : updateValue
      })
    }
  })
}
function clearCookie() {
  const token = getToken('key')
  var keys = document.cookie.match(/[^ =;]+(?==)/g)
  if (keys) {
    for (var i = keys.length; i--;) {
      if (keys[i].endsWith('_isFirst') && keys[i] !== `${token}_isFirst`) {
        document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的cookie
      }
    }
  }
}
